<template>
  <div>
    <banner />
    <div class="absolutecont">
      <div class="web">
        <div class="commonbg">
          <tab cur="/friends" />
          <div class="mainbody">
            <div class="Conpartanyxq">
              <div class="ProductDetailstop clearfix">
                <div class="friends-div">
                  <div style="width: 60%">
                    <h4>安徽数地空间信息科技有限公司
                    </h4>
                    <p>专注于智慧管网、智慧粮食、三维实景建模数据处理、低空摄影测量与遥感服务、无人机实景三维软、硬件产品方案提供为主要业务方向的高新技术企业。</p>
                  </div>
                  <div style="width: 40%">
                    <img :src="baseApi+'upload/about/f1.png'" >
                  </div>
                </div>
                <div class="friends-div">
                  <div style="width: 60%">
                    <h4>合肥八方地动科技有限公司
                    </h4>
                    <p>专注于应用地震学方法和人工智能技术分析微小震动分布特征的研究，业务范围涉及地震预警、交通监测、桥梁监测、新能源开发与监测等，更可用于失能独居等群体的健康监测。
                    </p>
                  </div>
                  <div style="width: 40%">
                    <img :src="baseApi+'upload/about/f2.png'" >
                  </div>
                </div>
              </div>
              <div style="height: 200px"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Banner from '@/views/us/componets/Banner'
import Tab from '@/views/us/componets/Tab'
export default {
  components: { Banner, Tab },
  data () {
    return {
      baseApi: process.env.API_ROOT + 'static/'
    }
  },
  mounted () {
  },
  methods: {
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.friends-div {
  display: flex;
  margin: 40px 10px;
  h4 {
    font-size: 25px;
    font-weight: bold;
    color: #548280;
    line-height: 50px;
  }
  p {
    font-size: 18px;
    line-height: 40px;
    width: 80%;
  }
  img {
    width: 300px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/us/friends.vue